import { type PropsWithChildren } from 'react'
import { getAriaLabel } from 'shared/lib'
import styles from './styles.module.scss'

type IDefaultModalActionsProps = PropsWithChildren & {
  ariaLabel?: string
}

export const DefaultModalActions = ({
  children,
  ariaLabel = 'DefaultModal',
}: IDefaultModalActionsProps) => {
  return (
    <div className={styles.actions} aria-label={getAriaLabel(ariaLabel, 'actions')}>
      {children}
    </div>
  )
}
